import React from "react";

const ContactUs = () => {
  return (
    <div class="p-6 rounded-lg">
      <h2 class="text-xl font-semibold text-green-700">Contact Person:</h2>
      <p class="text-lg font-bold text-green-800">Adv. V. K. Singh</p>

      <div class="mt-4">
        <h3 class="text-xl font-semibold text-green-700">Registered Office:</h3>
        <p class="text-gray-800">
          S.C.O. 29, 3rd Floor, Sector-13, Main Market, Urban Estate,
          KARNAL-132001.
        </p>
      </div>

      <div class="mt-4">
        <h3 class="text-xl font-semibold text-green-700">Corporate Office:</h3>
        <p class="text-gray-800">
          #259-60, EGI Complex, Near Smart Homes Sector 32-A, Buddha Khera,
          Karnal, Haryana-132001.
        </p>
      </div>

      <div class="mt-4">
        <h3 class="text-xl font-semibold text-green-700">Branch Office:</h3>
        <p class="text-gray-800">
          <strong>Madhya Pradesh:</strong> Bhopal, Indore, Jabalpur
          <br />
          <strong>Himachal Pradesh:</strong> Solan,Bilaspur
          <br />
          <strong>Uttar Pradesh:</strong> Etah, Hathras, Kanpur, Allahabad
          <br />
        </p>
      </div>

      <div class="mt-4 flex flex-col md:flex-row gap-8">
        <div class="flex flex-col">
          <p class="text-xl font-semibold text-green-700">Mobile:</p>
          <p class="text-gray-800">
            <strong>95413-22229</strong>, <strong>93556-02224</strong>,{" "}
            <strong>8901322234</strong>
          </p>

          <p class="mt-4 text-xl font-semibold text-green-700">E-mail:</p>
          <p class="text-green-800">
            <strong>
              <a href="mailto:info@excellentiasacademy.org">
                ecakarnal@gmail.com
              </a>
            </strong>
          </p>

          <p class="mt-4 text-xl font-semibold text-green-700">Website:</p>
          <p class="text-green-800">
            <strong>
              <a href="http://www.excellentiasacademy.com" target="_blank">
                www.excellentiasacademy.com
              </a>
            </strong>
          </p>
        </div>
        {/* <div class="flex flex-col">
          <p class="text-xl font-semibold text-green-700">Phone:</p>
          <p class="text-gray-800">
            <strong>0184-2207540</strong>, <strong>0184-2207541</strong>,{" "}
            <strong>0184-2207542</strong>
          </p>

          <p class="mt-4 text-xl font-semibold text-green-700">Fax:</p>
          <p class="text-gray-800">
            <strong>0184-2207541</strong>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default ContactUs;
